import React, { useEffect } from 'react';

import { NextPage } from 'next';
import { NextSeo, NextSeoProps } from 'next-seo';

import Head from 'next/head';

import { useIntl } from 'react-intl';

import NiceModal from '@ebay/nice-modal-react';

import * as prismicR from '@prismicio/richtext';

import { MessageModal } from '@components/overlays/Message';
import { Button } from '@components/atoms/Button';

import { ProductDetailsFragment } from '@sdk/gqlTypes/generatedOperations';
import { PrismicProductPageQuery } from '@prismic/gqlTypes/prismicOperations';
import { useCheckout } from '@sdk/providers/CheckoutProvider';

import { usePrismicLayout } from '@prismic/context';

import { structuredData } from '@temp/core/SEO/Product/structuredData';

import Page from './Page';

export interface ViewProps {
  params: { slug: string; id: string };
  product: ProductDetailsFragment | null;
  productDetails: PrismicProductPageQuery['product'] | null;
  seo: NextSeoProps | null;
}

const View: NextPage<ViewProps> = ({
  product,
  productDetails,
  seo,
  params: { id: productId },
}) => {
  const { addItem, checkout } = useCheckout();
  const items = checkout?.lines || [];

  const { layout } = usePrismicLayout();
  const intl = useIntl();

  useEffect(() => {
    const modal = layout?.modals?.find(
      (m) => m?.id === 'modal-configurator-new-website'
    );
    if (modal) {
      NiceModal.show(MessageModal, {
        title: modal.title,
        text: prismicR.asText(modal.text),
        // image: desktopIcon,
        content: (
          <Button
            type="button"
            onClick={() => NiceModal.hide(MessageModal)}
            fullWidth
          >
            {intl.formatMessage({
              defaultMessage: 'Okay',
              id: 'gZlFBP',
            })}
          </Button>
        ),
      });
    }
  }, [layout]);

  return (
    <>
      <NextSeo {...seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: structuredData(product) }}
          key="product-jsonld"
        />
      </Head>
      <Page
        product={product}
        productDetails={productDetails}
        addToCart={addItem}
        items={items}
      />
    </>
  );
};

export default View;
